export const isOfferPriceBookNameMismatch = (
    offerPriceBookName: string | null,
    addressPriceBookName: string | null,
    isAuctionOrderType: boolean,
    transactionType: string | null
): boolean => {
    if (transactionType && !['NEGOTIABLE', 'PRE_AUTH_NEGOTIATION'].includes(transactionType)) {
        // not an offer
        return false;
    }

    if (isAuctionOrderType) {
        // auctions are excepted from priceBook logic
        return false;
    }

    if (!offerPriceBookName || !addressPriceBookName) {
        // one or more invalid priceBookNames
        return false;
    }

    return offerPriceBookName !== addressPriceBookName;
};
